import { arrayUnion, doc, serverTimestamp, updateDoc } from 'firebase/firestore'
import { firestoreDb } from '../firebase'

const DEVICE_ID_STORAGE_KEY = 'helper.deviceId'

const generateId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `dev-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}

export const getOrCreateHelperDeviceId = (): string => {
  if (typeof window === 'undefined') return generateId()
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY)
    if (existing) return existing
    const next = generateId()
    window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, next)
    return next
  } catch {
    return generateId()
  }
}

export const recordHelperDeviceBinding = async (uid: string): Promise<{ deviceId: string; isNewDevice: boolean }> => {
  const deviceId = getOrCreateHelperDeviceId()
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown'
  const ref = doc(firestoreDb, 'users', uid)
  let isNewDevice = false
  try {
    await updateDoc(ref, {
      deviceBindings: arrayUnion({
        deviceId,
        userAgent,
        boundAt: new Date().toISOString(),
      }),
      lastHelperBindingAt: serverTimestamp(),
    })
    isNewDevice = true
  } catch {
    // Either doc missing or rules denied. Phase 1 soft-warn: don't block sign-in on this.
  }
  return { deviceId, isNewDevice }
}
